// extracted by mini-css-extract-plugin
module.exports = {"crossBtn":"Cross_crossBtn__3-Yro"};